import { Card, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import React from 'react';

interface StatCardProps {
  title: string;
  value: number | React.ReactNode;
  prefix?: React.ReactNode;
  suffix?: string;
  precision?: number;
  trend?: 'up' | 'down';
  color?: string;
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  prefix,
  suffix,
  precision,
  trend,
  color = '#3f8600',
  onClick,
}) => {
  const getPrefix = () => {
    if (prefix) return prefix;
    if (trend === 'up') return <ArrowUpOutlined />;
    if (trend === 'down') return <ArrowDownOutlined />;
    return null;
  };

  return (
    <Card
      hoverable={!!onClick}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : {}}
    >
      {typeof value === 'number' ? (
        <Statistic
          title={title}
          value={value}
          precision={precision}
          valueStyle={{ color: trend === 'down' ? '#cf1322' : color }}
          prefix={getPrefix()}
          suffix={suffix}
        />
      ) : (
        <div style={{ textAlign: 'center', padding: 8 }}>
          <div style={{ color: '#888', fontSize: 14 }}>{title}</div>
          {value}
        </div>
      )}
    </Card>
  );
};

export default StatCard;
